import httpClient, {
	FormMultiPart,
	FormUrlEncoded,
	ApplicationJson,
	POST,
	PUT,
	GET,
	DELETE
} from '../axios-httpclient';
import apiConfig from '@/api/apiConfig';
import commonFunc from '@/common/commonFunction';

export const NumberRetry = 180; //lần
export const NumberTimeOutRetry = 2000; //Miliseconds

export default class BaseAPI {
	constructor() {}
	baseUrl = '';
	controllerName = '';
	urlName = '';
	masterEntityName = '';
	detailEntityName = '';
	apiList = apiConfig;

	//khởi tạo ApiUrl
	// created by NDQUAN 20/08/2019
	//API được khởi tạo dựa trên urlName
	initAPI() {
		if (this.urlName) {
			this.baseUrl = apiConfig[this.urlName] + '/' + this.controllerName;
		}
	}

	//Build api url
	//CreatedBy NDQUAN 20/08/2019
	getAPIUrl() {
		// Khi base url chưa khởi tạo
		if (this.baseUrl == '') {
			this.initAPI();
		}

		//Nếu có truyền thêm argument thì nó khởi tạo thêm url
		if (arguments && arguments.length > 0) {
			return commonFunc.combineUrl(this.baseUrl, ...arguments);
		}

		return this.baseUrl;
	}
	initParamAPI(param) {
		if (this.urlName) {
			return (
				apiConfig[this.urlName] +
				'/' +
				param +
				'/' +
				this.controllerName
			);
		}
	}
	getAPIUrlSubParam(param) {
		// Khi base url chưa khởi tạo
		return this.initParamAPI(param);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async postAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await httpClient.requestAsync(
			config,
			POST,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async putAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await httpClient.requestAsync(
			config,
			PUT,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async getAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await httpClient.requestAsync(
			config,
			GET,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async deleteAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await httpClient.requestAsync(
			config,
			DELETE,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}
}
